import Component from '@glimmer/component';

import type {
  BarData,
  SymmetryData,
} from '../../../types/components/prism/data-bar.ts';
import {
  COLOR_TEXT_CRITICAL,
  COLOR_TEXT_DEFAULT,
  COLOR_TEXT_SUCCESS,
  COLOR_TRAFFIC_LIGHT_NEGATIVE,
  COLOR_TRAFFIC_LIGHT_POSITIVE,
  getCssVariableValue,
} from '../../../utils/css-variable.ts';
import PrismDataBarDataBarLabelValueTarget from './data-bar-label-value-target.gts';
import styles from './data-bar-symmetric-with-label-and-value.module.css';

interface PrismDataBarDataBarSymmetricWithLabelAndValueSignature {
  Args: {
    data: SymmetryData;
  };
  Element: HTMLDivElement;
}

export default class PrismDataBarDataBarSymmetricWithLabelAndValue extends Component<PrismDataBarDataBarSymmetricWithLabelAndValueSignature> {
  get negativeData(): BarData[] {
    const { data } = this.args;

    return [
      {
        backgroundColor: getCssVariableValue(COLOR_TRAFFIC_LIGHT_NEGATIVE),
        widthPercentage: data.negativeWidthPercentage,
      },
    ];
  }

  get positiveData(): BarData[] {
    const { data } = this.args;

    return [
      {
        backgroundColor: getCssVariableValue(COLOR_TRAFFIC_LIGHT_POSITIVE),
        widthPercentage: data.positiveWidthPercentage,
      },
    ];
  }

  get valueColor(): string {
    const { data } = this.args;

    if (data.value < 0) {
      return getCssVariableValue(COLOR_TEXT_CRITICAL);
    }

    if (data.value > 0) {
      return getCssVariableValue(COLOR_TEXT_SUCCESS);
    }

    return getCssVariableValue(COLOR_TEXT_DEFAULT);
  }

  <template>
    <div class={{styles.container}}>
      <PrismDataBarDataBarLabelValueTarget
        @data={{this.negativeData}}
        @direction="reverse"
        @rounded="left"
        as |DataBar|
      >
        <DataBar.label @color={{@data.labelColor}} @text={{@data.label}} />
      </PrismDataBarDataBarLabelValueTarget>

      <PrismDataBarDataBarLabelValueTarget
        @data={{this.positiveData}}
        @rounded="right"
        as |DataBar|
      >
        <DataBar.value
          @color={{this.valueColor}}
          @text={{@data.formattedValue}}
          @tooltip={{@data.valueTooltip}}
        />
      </PrismDataBarDataBarLabelValueTarget>
    </div>
  </template>
}
